














































































import {Component, Mixins} from 'vue-property-decorator';
import SettingsTabMixin from '@/mixins/settings/SettingsTabMixin';
import BasePrimeCost from './tabs/BasePrimeCost.vue';
import MaterialExpenseRatio from './tabs/MaterialExpenseRatio.vue';
import GlueExpenseRatio from './tabs/GlueExpenseRatio.vue';
import CNumberField from '@/components/base/numberField/CNumberField.vue';
@Component({
    components: {CNumberField},
})
export default class MarginCalculation extends Mixins(SettingsTabMixin) {
    private tab: number = 0;

    get tabConfig() {
        return [
            {
                name: this.$t('Systems.Settings.BasePrimecost'),
                component: BasePrimeCost,
            },
            {
                name: this.$t('Systems.Settings.MaterialExpenseRatio'),
                component: MaterialExpenseRatio,
            },
            {
                name: this.$t('Systems.Settings.GlueExpenseRatio'),
                component: GlueExpenseRatio,
            },
        ];
    }

    validate() {
        let correct = true;
        const items = this.$refs.content as any;
        for (let i = 0; i < items.length; i++) {
            const validation = items[i].validate();
            if (!validation.valid) {
                this.tab = validation.tab;
                correct = false;
                break;
            }
        }
        return {
            valid: correct && (this.$refs.form as any).validate(),
            tab: this.tabKey,
        };
    }
}
